import { graphql } from "@/gql/__generated__";

export const myPageQuery = graphql(`
  query MyPage {
    profile {
      id
      birthday
      firstName
      imageId
      imageUrl
      lastName
      nearestStationName
      authenticated
      occupation {
        id
        name
      }
      sex
    }
    usageStatus {
      absenceCount
      confirmedWorkConditionRate
      goodRate
      totalWageAmount
      totalWorkingHour
      workedCount
      goodReviewCount
      badReviewCount
      lateCancellationCountThisMonth
      monthlyWorkedCount
      monthlyCampaignEligibleWorkedCount
      monthlyTotalWorkingHour
      employedCount
      trustScore {
        noEvaluationRecord
        grade
        displayName
        basis
        workedCount
        absenceCount
        lateCancellationCount
        rate
        requiredWorkCountForNextGrade
        nextGradeDisplayName
      }
      cancellationStatsLastThreeMonths {
        cancellationRate
        lateCancellationRate
        workedCount
        cancellationCount
        lateCancellationCount
        resolvedCount
      }
      cancellationStatsAllPeriod {
        cancellationRate
        lateCancellationRate
        workedCount
        cancellationCount
        lateCancellationCount
        resolvedCount
      }
    }
    temporaryJobWorker {
      id
      points
      smsExclude
      isExistNewAnnouncement
    }
    viewer {
      id
      status
      isSuspended
      suspensionStartDateAt
      suspensionEndDateAt
      applicationStatus {
        currentCount
        limit
      }
      unreviewedCount
      isFirstWorkMonth
      hasProfile
      hasBankAccount
      isIdentification
    }
  }
`);

export const followedByOfficeCountQuery = graphql(`
  query FollowedByOfficeCount {
    viewer {
      id
      followedByOfficeCount
    }
  }
`);

export const updateProfileMutation = graphql(`
  mutation UpdateResumeProfile($input: UpdateResumeProfileInput!) {
    updateResumeProfile(input: $input) {
      temporaryJobWorker {
        id
        profile {
          id
          birthday
          firstName
          imageId
          imageUrl
          lastName
          firstNameKana
          lastNameKana
          sex
          nationality
          hasDriversLicense
          desiredWithinRange
          desiredTimeSlot
          motivationOfJobChange
        }
        caregiverExperience {
          employmentPeriod
          id
          businessGenres {
            id
            name
          }
          jobCategories {
            id
            name
          }
        }
      }
    }
  }
`);

export const nationalitiesQuery = graphql(`
  query Nationalities {
    nationalities
  }
`);

export const occupationQuery = graphql(`
  query Occupations {
    occupations {
      id
      name
    }
  }
`);

export const jobCategoriesQuery = graphql(`
  query JobCategories {
    jobCategories {
      id
      name
    }
  }
`);

export const logoutMutation = graphql(`
  mutation Logout($input: LogoutInput!) {
    logout(input: $input) {
      temporaryJobWorker {
        id
      }
    }
  }
`);

export const businessGenresQuery = graphql(`
  query BusinessGenres {
    businessGenres {
      id
      name
    }
  }
`);

export const caregiverExperienceJobCategoriesQuery = graphql(`
  query CaregiverExperienceJobCategories {
    caregiverExperienceJobCategories {
      id
      name
    }
  }
`);

export const temporaryJobWorkerReviewsQuery = graphql(`
  query TemporaryJobWorkerReviews($reviewType: String) {
    temporaryJobWorkerReviews(reviewType: $reviewType) {
      id
      evaluation
      reviewerName
      reviewedDate
      comment
    }
  }
`);

export const pointSystemDisplayTablesQuery = graphql(`
  query PointSystemDisplayTables {
    pointSystemDisplayTables {
      penaltyRules {
        cancelTime
        penaltyPoint
      }
    }
  }
`);

export const workerPointHistoriesQuery = graphql(`
  query WorkerPointHistories($first: Int!, $after: String) {
    workerPointHistories(first: $first, after: $after) {
      edges {
        node {
          id
          displayLabel
          pointsChange
          balanceAfter
          createdAt
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`);

export const identityVerificationStatusQuery = graphql(`
  query IdentityVerificationStatus {
    profile {
      id
      authenticated
    }
  }
`);

export const analyticsIdQuery = graphql(`
  query AnalyticsId {
    analyticsId
  }
`);
